"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _reactHooks = require("@trycourier/react-hooks");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _format_digest = _interopRequireWildcard(require("../utils/format_digest"));

var DigestScheduleContainer = _styledComponents["default"].div.withConfig({
  displayName: "DigestSchedule__DigestScheduleContainer",
  componentId: "xp12a7-0"
})(["display:flex;flex-direction:row;margin:12px 0px;align-items:flex-start;.digest-details{display:flex;flex-direction:column;margin-left:12px;.digest-period{font-size:14px;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:6px;font-weight:bold;}.digest-repetition{font-size:12px;color:#73819b;}}"]);

var StyledRadio = _styledComponents["default"].input.withConfig({
  displayName: "DigestSchedule__StyledRadio",
  componentId: "xp12a7-1"
})(["height:14px;width:14px;margin-top:4px !important;accent-color:", ";"], function (_ref) {
  var checkedColor = _ref.checkedColor;
  return checkedColor;
});

var DigestSchedules = function DigestSchedules(_ref2) {
  var checkedColor = _ref2.checkedColor,
      schedules = _ref2.schedules,
      onScheduleChange = _ref2.onScheduleChange,
      topicId = _ref2.topicId;

  var _usePreferences = (0, _reactHooks.usePreferences)(),
      recipientPreferences = _usePreferences.recipientPreferences;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  (0, _react.useEffect)(function () {
    var defaultSchedule = schedules.find(function (s) {
      return s["default"];
    });
    var userPreference = recipientPreferences === null || recipientPreferences === void 0 ? void 0 : recipientPreferences.find(function (pref) {
      return pref.templateId === topicId;
    });

    if (userPreference !== null && userPreference !== void 0 && userPreference.digestSchedule && schedules.find(function (s) {
      return s.scheduleId === userPreference.digestSchedule;
    })) {
      setSelectedOption(userPreference.digestSchedule);
    } else {
      setSelectedOption(defaultSchedule === null || defaultSchedule === void 0 ? void 0 : defaultSchedule.scheduleId);
    }
  }, [recipientPreferences, schedules]);

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    setSelectedOption(value);
    onScheduleChange(value);
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, schedules.map(function (schedule) {
    return /*#__PURE__*/_react["default"].createElement(DigestScheduleContainer, {
      key: schedule.scheduleId
    }, /*#__PURE__*/_react["default"].createElement(StyledRadio, {
      type: "radio",
      value: schedule.scheduleId,
      checked: selectedOption === schedule.scheduleId,
      checkedColor: checkedColor,
      onChange: handleChange
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "digest-details"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "digest-period"
    }, (0, _format_digest["default"])(schedule)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "digest-repetition"
    }, (0, _format_digest.toUpperCaseFirstLetter)(schedule.repetition))));
  }));
};

var _default = DigestSchedules;
exports["default"] = _default;